import { useState, useEffect } from 'react';
import { Container, Typography, TextField, Button, Box, Alert, Paper, Grid } from '@mui/material';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import LockResetIcon from '@mui/icons-material/LockReset';
import LogoutDialog from '../components/LogoutDialog'; // Το path σου
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

export default function AccountPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [statusInfo, setStatusInfo] = useState({ type: '', msg: '' });
  const [statusPassword, setStatusPassword] = useState({ type: '', msg: '' });
  const [openLogout, setOpenLogout] = useState(false);
  const [saving, setSaving] = useState(false);

  // Προσδιορισμός του ποιο view θα δείξουμε
  const isChangePassword = location.pathname.includes('change-password');
  const isChangeInfo = location.pathname.includes('change-info');
  const isMainPage = !isChangePassword && !isChangeInfo;

  const [user, setUserState] = useState(() => {
    const saved = localStorage.getItem('user');
    return saved ? JSON.parse(saved) : { id: null, name: '', email: '', telephone: '' };
  });

  const [formInfoData, setFormInfoData] = useState({
    name: user.name,
    email: user.email,
    telephone: user.telephone
  });
  const [formPasswordData, setFormPasswordData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });

  const handleChangeInfo = (e) => {
    setFormInfoData({ ...formInfoData, [e.target.name]: e.target.value });
  };

  const handleUpdateInfo = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/change-info`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formInfoData)
      });

      if (response.ok) {
        localStorage.setItem('user', JSON.stringify({ ...user, name: formInfoData.name, email: formInfoData.email, telephone: formInfoData.telephone }));
        setUserState({ ...user, name: formInfoData.name, email: formInfoData.email, telephone: formInfoData.telephone });
        setStatusInfo({ type: 'success', msg: 'Η ενημέρωση ολοκληρώθηκε!' });
      }
    } finally {
      setSaving(false);
    }
  };

  const handleChangePassword = (e) => {
    setFormPasswordData({ ...formPasswordData, [e.target.name]: e.target.value });
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/change-password`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formPasswordData)
      });

      const response_data = await response.json();

      if (response.ok) {
        setStatusPassword({ type: 'success', msg: 'Η αλλαγή password ολοκληρώθηκε!' });
        setFormPasswordData({ ...formPasswordData, current_password: '', new_password: '', confirm_password: '' });
      } else {
        setStatusPassword({ type: 'error', msg: response_data.message });
      }
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (isMainPage === true) {
      setStatusInfo({ type: '', msg: '' });
      setStatusPassword({ type: '', msg: '' });
    }
  }, [isMainPage]);


  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        {isMainPage && "Ο λογαριασμός μου"}
        {isChangeInfo && "Επεξεργασία Στοιχείων"}
        {isChangePassword && "Αλλαγή Συνθηματικού"}
      </Typography>



      <Paper sx={{ p: 4, mt: 3, borderRadius: 2 }}>
        {isMainPage ? (
          /* --- VIEW 1: ΕΜΦΑΝΙΣΗ ΣΤΟΙΧΕΙΩΝ (MAIN) --- */
          <Box>
            <Grid container spacing={3}>
              <Grid size={12}>
                <Typography variant="subtitle2" color="text.secondary">Όνομα</Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>{user.name}</Typography>
              </Grid>

              <Grid size={12}>
                <Typography variant="subtitle2" color="text.secondary">Email</Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>{user.email}</Typography>
              </Grid>

              <Grid size={12}>
                <Typography variant="subtitle2" color="text.secondary">Τηλέφωνο</Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>{user.telephone}</Typography>
              </Grid>
            </Grid>

            <Box sx={{ mt:3, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
              <Button component={Link} to="/account/change-info" variant="contained" size="large" startIcon={<EditIcon />} >Επεξεργασία Στοιχείων</Button>
              <Button component={Link} to="/account/change-password" variant="contained" size="large" startIcon={<LockResetIcon />} >Αλλαγή Password</Button>
              <Button variant="contained"   color="error" startIcon={<ExitToAppIcon />} size="large" onClick={() => setOpenLogout(true)}> Αποσύνδεση </Button>
              <LogoutDialog
                open={openLogout}
                onClose={() => setOpenLogout(false)}
              />
            </Box>
          </Box>
        ) : (
          /* --- VIEW 2 & 3: FORM (INFO ή PASSWORD) --- */
          <>
            {isChangeInfo ? (
              <Box component="form" onSubmit={handleUpdateInfo}>
                {statusInfo.msg && <Alert severity={statusInfo.type} sx={{ mb: 2 }}>{statusInfo.msg}</Alert>}
                <TextField label="Όνομα" name="name" value={formInfoData.name} onChange={handleChangeInfo} fullWidth sx={{ mb: 3 }} />
                <TextField label="Email" name="email" value={formInfoData.email} onChange={handleChangeInfo} fullWidth sx={{ mb: 3 }} />
                <TextField label="Τηλέφωνο" name="telephone" value={formInfoData.telephone} onChange={handleChangeInfo} fullWidth sx={{ mb: 3 }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  <Button type="submit" variant="contained" size="large" >Αποθήκευση</Button>
                  <Button type="button" component={Link} to="/account"  >Επιστροφή</Button>
                </Box>
              </Box>
            ) : (
              <Box component="form" onSubmit={handleUpdatePassword}>
                {statusPassword.msg && <Alert severity={statusPassword.type} sx={{ mb: 2 }}>{statusPassword.msg}</Alert>}
                <TextField label="Τρέχον Password" name="current_password" type="password" value={formPasswordData.current_password} onChange={handleChangePassword} fullWidth required sx={{ mb: 3 }} />
                <TextField label="Νέο Password" name="new_password" type="password" value={formPasswordData.new_password}  onChange={handleChangePassword} fullWidth required sx={{ mb: 3 }} />
                <TextField label="Επιβεβαίωση Νέου Password" name="confirm_password" value={formPasswordData.confirm_password}  type="password" onChange={handleChangePassword} fullWidth required sx={{ mb: 3 }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  <Button type="submit" variant="contained" size="large" >Αποθήκευση</Button>
                  <Button type="button" component={Link} to="/account"  >Επιστροφή</Button>
                </Box>
              </Box>
            )}


          </>
        )}
      </Paper>
    </Container>
  );
}
